<app-product-kit-header [img]="product.image_header.path" [subtitle]="product.series.name" [title]="product.name"
                        [phyInfo]="product.phy_info" [description2]="product.applications|implode: 'name'"
                        [description]="product.description"></app-product-kit-header>

<app-product-kit-gallery [gallery]="product.images_gallery" [buttons]="buttons"></app-product-kit-gallery>

<div class="container">
  <div class="row" *ngIf="product.variations?.length">
    <div class="col-60">
      <div class="box-models">
        <!--        <app-section-title3 [title]="'label_variations' | translate" color="danger"></app-section-title3>-->
        <div *ngFor="let item of product.variations" class="box-kit-model">
          <app-box-product-model [diameters]="item.diameters" [voltages]="item.voltages"
                                 [code]="item.sku"></app-box-product-model>
        </div>
      </div>
    </div>
  </div>

  <!-- SECTION CASE STUDIES -->
  <div class="row mt-5 mb-5">
    <div class="col-60 col-md-20 mb-3 mb-md-0 align-content-center">
      <img class="w-100"
           src="https://media.elsasrl.com/storage/elsa-platform/media/be-xtra/case-studies-section-image.png"
           alt="Elsa sectors image"/>
    </div>
    <div class="col-60 col-md-40">
      <app-section-title2 [title]="'label_case_studies_title' | translate" color="dark"></app-section-title2>
      <p>{{'label_case_studies_first_paragraph' | translate}}<br/>{{'label_case_studies_second_paragraph' | translate}}
      </p>
      <ul>
        <li>{{'label_case_studies_first_sector' | translate}} - <a class="orange-link"
                                                                   [href]="'label_case_studies_first_sector_link' | translate">{{'label_discover_more' | translate}}</a>
        </li>
        <li>{{'label_case_studies_second_sector' | translate}} - <a class="orange-link"
                                                                    [href]="'label_case_studies_second_sector_link' | translate">{{'label_discover_more' | translate}}</a>
        </li>
      </ul>
      <p>{{'label_case_studies_generic_cta_label' | translate}} <a class="orange-link"
                                                                   [href]="'label_case_studies_generic_cta_link' | translate">{{'label_case_studies_generic_cta_action' | translate}}</a>
      </p>
    </div>
  </div>

  <!-- SECTION TECH SPEC -->
  <app-section-title2 [title]="'label_tech_spec' | translate" color="dark"></app-section-title2>
  <div class="row mt-3 mb-3">
    <div class="col">
      <div class="w-100 columns">
        <div class="box-technical-specifications break-inside-avoid"
             *ngFor="let item of product.datasheets; let isLast = last">
          <app-box-technical-specifications [title]="item.title"
                                            [img]="isLast ? product.image_dimensions.path : undefined"
                                            [items]="item.datasheetvalue"></app-box-technical-specifications>
        </div>
      </div>
    </div>
    <div class="col-60">
      <div class="box-technical-specifications box-technical-specifications-with-border">
        <app-box-equipment [title]="'label_standard_equipment' | translate" color="dark"
                           [items]="product.equipments"></app-box-equipment>
      </div>
    </div>
  </div>
</div>

<app-product-warranty-banner></app-product-warranty-banner>

<app-product-footer *ngIf="staticData" [firstBannerData]="staticData[staticPageContent.kit]"
                    [secondaryBannerData]="staticData[staticPageContent.accessories]" [kit]="product.kitseries"
                    [hasFilters]="false"
                    [startWithFilter]="product.name_slug"></app-product-footer>

<div class="padding-go-up-button"></div>
<app-video-image-gallery #videoGallery [items]="product.videos_gallery"></app-video-image-gallery>
<app-video-image-gallery #imageGallery [items]="product.images_secondary_gallery"></app-video-image-gallery>
<app-script-ld-json *ngIf="schema" [json]="schema"></app-script-ld-json>

<app-link-popup-dialog></app-link-popup-dialog>
